import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { hideModal } from '../../../../actions/modal';
import { unpauseHomework } from '../../../../actions/status';
import { printTime } from '../../../../lib/utils';
import { HOMEWORK_EXECUTION } from '../../../../constants/routes';
import { useOnlineStatus } from '../../../../lib/hooks';
import Spacer from '../../../spacer';

import Buttons from '../../buttons';
import Modal from '../..';
import { Content, ModalBodyContainer } from '../../components';

export const Message = styled.span``;
export const LeftTime = styled.span``;
export const InitialTime = styled.span`
    font-style: 'italic';
`;

export const ResumeHomeworkModalBody = ({ onClose, unpauseHomework, leftTime, initialTime, status, saveStatus }) => {
    const history = useNavigate();
    const onlineStatus = useOnlineStatus();
    const formattedLeftTime = printTime(leftTime);
    const formattedInitialTime = printTime(initialTime);

    const onResume = async () => {
        unpauseHomework(status, saveStatus);
        onClose();
        setTimeout(history, 0, HOMEWORK_EXECUTION, { replace: true });
    };

    return (
        <Modal title="Vuoi riprendere la prova?" onClose={onClose}>
            <ModalBodyContainer>
                <Content>
                    {initialTime ? (
                        <div>
                            <Message className="body-3">{'Tempo rimasto per completare la prova: '}</Message>
                            <LeftTime className="body-3-sb">{formattedLeftTime}</LeftTime>
                            <Spacer size="small" />
                            <InitialTime className="body-5">{`Tempo iniziale: ${formattedInitialTime}`}</InitialTime>
                        </div>
                    ) : (
                        <Message className="body-3">{'Riprendi dal punto in cui hai messo in pausa.'}</Message>
                    )}
                </Content>
                <Buttons
                    primaryButtonClick={onResume}
                    primaryButtonDisabled={!onlineStatus}
                    primaryButtonText="Riprendi"
                    tertiaryButtonClick={onClose}
                    tertiaryButtonText="Rimani in pausa"
                />
            </ModalBodyContainer>
        </Modal>
    );
};

ResumeHomeworkModalBody.propTypes = {
    onClose: PropTypes.func,
    unpauseHomework: PropTypes.func,
    leftTime: PropTypes.number,
    initialTime: PropTypes.number,
    status: PropTypes.object,
    saveStatus: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        leftTime: state.status.remainingTime,
        initialTime: state.application.time,
        status: state.status,
        saveStatus: state.application.saveStatus,
    };
};

const actionCreators = {
    onClose: hideModal,
    unpauseHomework: unpauseHomework,
};

export default connect(mapStateToProps, actionCreators)(ResumeHomeworkModalBody);
